module.exports = __webpack_public_path__ + "img/btn.0e2f84c9.png";